import React, { useState } from 'react';
import funcTranslateHelper from '../../../i18next/funcTranslateHelper';
import CryptoJS from 'crypto-js';
import { Button, Loading } from 'carbon-components-react';

const CustomFileHashInput = props => {
  const [uploadingFile, setUploadingFile] = useState(false);
  const [key, setKey] = useState(props.formData || undefined);
  let label = props.schema.title;

  if (props.required) label += ' *';

  const fileInputRef = React.createRef();

  function readFileAsync (file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        resolve(reader.result);
      };
      reader.onerror = () => reject(reader.error);
      reader.readAsArrayBuffer(file);
    });
  }

  async function onChangeFile (event) {
    setUploadingFile(true);

    const file = await readFileAsync(event.target.files[0]);
    const SHA256 = CryptoJS.algo.SHA256.create();
    const wordBuffer = CryptoJS.lib.WordArray.create(file);
    SHA256.update(wordBuffer);
    const encrypted = SHA256.finalize().toString();

    setKey(encrypted);
    setUploadingFile(false);
    props.onChange(encrypted);
  }

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        paddingTop: 10,
        marginTop: 14,
        alignItems: 'flex-start'
      }}
    >
      <div
        style={{
          marginBottom: 8,
          fontSize: '0.75rem',
          fontWeight: 400,
          lineHeight: '1rem',
          letterSpacing: 0.32,
          color: '#393939',
          display: 'inline-block',
          verticalAlign: 'baseline'
        }}
      >
        {label}
      </div>

      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center'
        }}
      >
        <Button
          size='field'
          onClick={() => {
            fileInputRef.current
              ? fileInputRef.current.click()
              : document.getElementById(props.idSchema.$id).click();
          }}
          style={{ paddingRight: 12, marginRight: 15 }}
          disabled={props.schema.readOnly}
        >
          {funcTranslateHelper('CustomFileHashInput.btn.file')}
        </Button>
        <div id={`${props.idSchema.$id}-div`}>
          {uploadingFile ? (
            <Loading active small withOverlay={false} />
          ) : (
            key
          )}
        </div>
        <input
          id={props.idSchema.$id}
          type='file'
          style={{ height: '100%', display: 'none' }}
          onChange={e => onChangeFile(e)}
        />
      </div>
    </div>
  );
};

export default CustomFileHashInput;
